/* ============================================================
   Piper & Leaf Mega Menu
   Custom element <pl-mega-menu>: hover-intent open/close, viewport
   clamp so a panel never runs off-screen, keyboard + outside close,
   and a featured carousel that auto-rotates only while its tab is open.
   ============================================================ */
   (function () {
    'use strict';
    if (customElements.get('pl-mega-menu')) return;
  
    var DESKTOP = '(min-width: 990px)';
    var REDUCE = '(prefers-reduced-motion: reduce)';
  
    class PLMegaMenu extends HTMLElement {
      connectedCallback() {
        this.mqDesktop = window.matchMedia(DESKTOP);
        this.reduce = window.matchMedia(REDUCE);
        this.items = Array.prototype.slice.call(
          this.querySelectorAll('.pl-mega__item--has-panel')
        );
        this.closeTimer = null;
        this.lastPointer = '';
  
        this._onPointer = function (e) { this.lastPointer = e.pointerType; }.bind(this);
        this._onDocClick = function (e) {
          if (!e.target.closest('.pl-mega__item--has-panel')) this.closeAll();
        }.bind(this);
        this._onKey = function (e) {
          if (e.key !== 'Escape') return;
          var open = this.querySelector('.pl-mega__item--has-panel.is-open');
          if (open) { this.close(open); var s = open.querySelector('.pl-mega__summary'); if (s) s.focus(); }
        }.bind(this);
        this._onResize = function () {
          if (!this.mqDesktop.matches) return;
          var open = this.querySelector('.pl-mega__item--has-panel.is-open');
          if (open) this.position(open);
        }.bind(this);
  
        document.addEventListener('pointerdown', this._onPointer, true);
        document.addEventListener('click', this._onDocClick);
        document.addEventListener('keydown', this._onKey);
        window.addEventListener('resize', this._onResize, { passive: true });
  
        this.mqChange = function () { this.closeAll(); }.bind(this);
        this.mqDesktop.addEventListener('change', this.mqChange);
  
        this.items.forEach(this.initItem.bind(this));
      }
  
      disconnectedCallback() {
        document.removeEventListener('pointerdown', this._onPointer, true);
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('keydown', this._onKey);
        window.removeEventListener('resize', this._onResize);
        if (this.mqDesktop) this.mqDesktop.removeEventListener('change', this.mqChange);
        clearTimeout(this.closeTimer);
        this.items.forEach(function (li) { if (li._carousel) li._carousel.stop(); });
      }
  
      initItem(li) {
        var self = this;
        var summary = li.querySelector('.pl-mega__summary');
        li._carousel = this.buildCarousel(li);
  
        summary.addEventListener('click', function () {
          li.classList.contains('is-open') ? self.close(li) : self.open(li);
        });
        // Click-to-toggle (no hover-open). The click handler above opens/closes;
        // click-outside, Escape, and focus-out (below) handle closing.
        li.addEventListener('focusout', function (e) {
          if (!li.contains(e.relatedTarget)) self.close(li);
        });
      }
  
      open(li) {
        this.closeAll(li);
        li.classList.add('is-open');
        var summary = li.querySelector('.pl-mega__summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
        this.position(li);
        if (li._carousel) li._carousel.start();
      }
  
      close(li) {
        li.classList.remove('is-open');
        var summary = li.querySelector('.pl-mega__summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
        if (li._carousel) li._carousel.stop();
      }
  
      closeAll(except) {
        this.items.forEach(function (li) {
          if (li !== except && li.classList.contains('is-open')) this.close(li);
        }, this);
      }
  
      /* Centre the panel under its tab, then clamp so it stays fully on-screen.
         Measured from transform-independent values, so it can't be skewed mid-animation. */
      position(li) {
        var panel = li.querySelector('.pl-mega__panel');
        if (!panel) return;
        var nav = li.getBoundingClientRect();           // panel left is measured from nav.left
        var w = panel.offsetWidth;                       // capped at 100vw - 28px by CSS
        var vw = document.documentElement.clientWidth, pad = 14;
        var want = nav.left + nav.width / 2 - w / 2;     // ideal: centred under the tab
        var left = Math.max(pad, Math.min(want, vw - pad - w));
        panel.style.left = Math.round(left - nav.left) + 'px';
      }
  
      buildCarousel(li) {
        var root = li.querySelector('.pl-mega__promo[data-pl-carousel]');
        if (!root) return null;
        var slides = Array.prototype.slice.call(root.querySelectorAll('.pl-mega__slide'));
        var dots = Array.prototype.slice.call(root.querySelectorAll('.pl-mega__dot'));
        if (slides.length < 2) return null;
  
        var idx = 0, timer = null, paused = false;
        var reduce = this.reduce;
  
        function render() {
          slides.forEach(function (s, i) {
            var on = i === idx;
            s.classList.toggle('is-active', on);
            s.setAttribute('aria-hidden', on ? 'false' : 'true');
            if (on) s.removeAttribute('tabindex'); else s.setAttribute('tabindex', '-1');
          });
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        function go(i) { idx = (i + slides.length) % slides.length; render(); }
  
        root.addEventListener('mouseenter', function () { paused = true; });   // let people read/click
        root.addEventListener('mouseleave', function () { paused = false; });
        root.addEventListener('focusin', function () { paused = true; });
        root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) paused = false; });
        dots.forEach(function (d, i) { d.addEventListener('click', function () { paused = true; go(i); }); });
  
        return {
          start: function () {
            this.stop(); idx = 0; render();
            // no autoplay when reduced-motion is on, or when the card is hidden (narrow widths)
            if (reduce.matches || root.offsetParent === null) return;
            timer = setInterval(function () { if (!paused) go(idx + 1); }, 2000);
          },
          stop: function () { if (timer) { clearInterval(timer); timer = null; } }
        };
      }
    }
  
    customElements.define('pl-mega-menu', PLMegaMenu);
  })();